import {
  PopularVisibleLanguagesList,
  TextToSpeechAvailableForLanguages
} from "../../constants";

const voiceSupportedLanguages = TextToSpeechAvailableForLanguages.join();
const popularVisibleLanguages = PopularVisibleLanguagesList.join(",");

export const getUserPreferredLanguageCode = () => {
  let langCode = new URLSearchParams(window.location.search).get("lang");

  return langCode;
};

export const initGoogleTranslateElement = (
  showAllLanguages,
  defaultLangCode
) => {
  if (defaultLangCode) {
    const cookieValue = `/en/${defaultLangCode}`;
    document.cookie = `googtrans=${cookieValue}; path=/`;
    document.cookie = `googtrans=${cookieValue}; domain=${window.location.hostname}; path=/`;
  }

  let options = {
    pageLanguage: "en",
    includedLanguages: showAllLanguages
      ? popularVisibleLanguages
      : voiceSupportedLanguages,
    layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
    autoDisplay: false
  };

  new window.google.translate.TranslateElement(
    options,
    "google_translate_element"
  );

  window.speechSynthesis.getVoices();
};

export const handleTranslateClick = (event) => {
  if (
    event?.target?.id === "google_translate_element" ||
    event?.target?.closest("#google_translate_element")
  ) {
    event.preventDefault();
  }
};

function changeGoogleStyles() {
  let iframeElement = $("iframe");
  let iframeBody = iframeElement?.contents().find("body");
  let container = iframeElement?.contents().find(".VIpgJd-ZVi9od-vH1Gmf");
  if (iframeElement.length && iframeBody.length && container.length) {
    let margin = 2;
    let width = $(window).width() - 10;
    container.css({
      overflow: "scroll",
      height: "290px",
      width: width + "px"
    });

    if (width <= 768) {
      container.css({
        overflow: "scroll",
        height: "290px",
        width: width + "px"
      });
    } else {
      container.css({
        overflow: "scroll",
        height: "270px",
        width: width + "px"
      });
    }

    iframeBody.css({ overflow: "none" });
    iframeElement.css({ left: margin + "px" });
  }
  if ($(".goog-te-menu-frame").contents().find("body").length) {
    $(".goog-te-menu-frame").contents().find("body").css({
      "overflow-x": "auto",
      "box-sizing": "border-box"
    });
  } else {
    setTimeout(changeGoogleStyles, 500);
  }
}

export const handleGoogleTranslatorOnPageLoad = (
  showAllLanguages = true,
  defaultLangCode = null
) => {
  if (document.getElementById("google-translate-script")) {
    return;
  }

  const script = document.createElement("script");

  script.id = "google-translate-script";
  script.src =
    "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  document.body.appendChild(script);

  window.googleTranslateElementInit = () => {
    initGoogleTranslateElement(showAllLanguages, defaultLangCode);
    if (showAllLanguages) {
      changeGoogleStyles();
    }
  };
  handleTranslateClick();
  document.addEventListener("click", handleTranslateClick);
};

export const getTranslatedLanguageCode = () => {
  const cookieValue = `; ${document.cookie}`;
  const parts = cookieValue.split(`; googtrans=`);

  if (parts.length >= 2) {
    const googtransValue = parts[1].split(";").shift();
    const targetLang = googtransValue.split("/")[2];

    return targetLang || null;
  }

  return null;
};
